import * as z from 'zod/v4';

export const completeGasDepositInput = z.object({
  quoteId: z.uuid(),
});

export type CompleteGasDepositInput = z.input<typeof completeGasDepositInput>;

export type CompleteGasDepositOutput = {
  transferId: string;
  requestId: string;
};
